export const PastDueConfig = {
    name            : 'Past due',
    icon            : 'i5-pastdue',
    image           : 'past-due', //isvg
    iconSvg         : 'isvg-view-past-due',
    url             : 'pastdue',
    description     : 'All overdue items with filters by deadline or start-end dates.',
    canBeInProject  : true,
}

export const CUSTOM_VIEW_PASTDUE_CONFIG = {
    ...PastDueConfig,
    // key2: "newValue2",  // Replacing the value for key2
}